import { Component, OnInit, Input } from '@angular/core';

import { ControlValidatorBase } from '../../types/validator.types';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'df-validate-message',
  templateUrl: './validate-message.component.html',
  styleUrls: ['./validate-message.component.css']
})
export class ValidateMessageComponent implements OnInit {
  @Input() validators: Array<ControlValidatorBase>;

  get validator(): ControlValidatorBase {
    if (!this.validators) {
      return { error: { success: true, message: '' } } as ControlValidatorBase;
    }
    return this.validators.find((s) => {
      if (s.error && !s.error.success) {
        return true;
      }
    });
  }
  constructor() {}

  ngOnInit() {}
}
